import { Store } from '../../typings';

const getDesignId = (store: Store) => store.design.designId;

export default getDesignId;
